import React from "react";
import PropTypes from "prop-types";
import { UserNameForm, UserEmailForm } from "components/settings/user-name-and-email-forms";

export const UserNameAndEmailSettings = ({
  email,
  firstName,
  lastName,
  onSaveUserEmail,
  onSaveUserName
}) => (
  <div>
    <h1>Name and Email</h1>
    <UserNameForm initialValues={ { name: firstName, surname: lastName } } onSaveUserName={ onSaveUserName } />
    <UserEmailForm email={ email } onSaveUserEmail={ onSaveUserEmail } />
  </div>
);

UserNameAndEmailSettings.propTypes = {
  email: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  onSaveUserEmail: PropTypes.func.isRequired,
  onSaveUserName: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/settings/user-name-and-email-settings.jsx